import React, { useState } from "react";
import ProductCard from "./ProductCard";
import ProductLgCard from "./ProductLgCard";
import "./style.scss";
import { ReactComponent as SearchIcon } from "../../../asset/icons/searchIcon.svg";
import { useTranslation } from "react-i18next";
export default function Bests() {
    const [startDate, setStartDate] = useState({
        fa: "1390-01-01",
        en: "2000-01-01",
    });
    const [endDate, setEndDate] = useState({
        fa: "1410-01-01",
        en: "2030-01-01",
    });
    const [filterType, setFilterType] = useState("item");
    const [startDatePicker, setStartDatePicker] = useState(false);
    const [endDatePicker, setEndDatePicker] = useState(false);
    const { t } = useTranslation();

    return (
        <div class="bests-card-container-main">
            <div className="toolbar">
                <div className="toolbar-type">
                    <div className="toolbar-ic pad-st-ic">
                        <SearchIcon />
                    </div>
                    <div className="toolbar-search">
                        <input
                            type="text"
                            placeholder={t(
                                "UserPanel.BestOffers.BestOfers.Search.Bar"
                            )}
                        />
                    </div>

                    <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                    >
                        <option value="item">
                            {t(
                                "UserPanel.BestOffers.BestOfers.Item.Drop.Filter"
                            )}
                        </option>
                        <option value="item_type">
                            {t(
                                "UserPanel.BestOffers.BestOfers.ItemType.Drop.Filter"
                            )}
                        </option>
                    </select>
                </div>
                <div className="toolbar-date"></div>
                <button>
                    {t("UserPanel.BestOffers.BestOfers.Apply.Button")}
                </button>
            </div>
            <div className="bests-card-container">
                <ProductCard />
                <ProductCard />
                <ProductCard />
                <ProductLgCard />
                <ProductCard />
                <ProductCard />
                <ProductCard />
                <ProductLgCard />
            </div>
        </div>
    );
}
